export const PREFERENCES_WIDTH = 180;
